import { Input, Modal } from 'antd';
import { useTranslate } from '@tolgee/react';
import { useToggle } from 'ahooks';
import { useEffect, useState } from 'react';
import { sellerMemosLimit } from 'views/Conversation/Sider/constants';
import { OrderQueryParams } from 'hooks/business/chat/useOrderList';
import { useOrderNoteMutationWithList } from 'hooks/business/chat/useOrderNote';
import { DefaultButton } from '../DefaultButton';

interface OrderNoteProps {
  isShopeeIn30daysMemo: boolean;
  internalTradeId: Conversation.Trade.Vo['internalTradeId'];
  platform: Conversation.Trade.Vo['platform'];
  content?: string;
  /** 用于乐观更新的查询参数 */
  queryParams?: OrderQueryParams;
  renderButton?: (isEditState: boolean, onClick: () => void) => React.ReactNode;
  editText?: string;
  addText?: string;
}

export const OrderNote = (props: OrderNoteProps) => {
  const { t } = useTranslate();

  const {
    isShopeeIn30daysMemo,
    internalTradeId,
    platform,
    content,
    queryParams,
    renderButton,
    editText = t('trade.updateComment'),
    addText = t('trade.createComment'),
  } = props;
  const [visible, { toggle }] = useToggle(false);

  const [inputValue, setInputValue] = useState(content);

  const isEditState = !!content;
  const buttonText = isEditState ? editText : addText;

  const showTips = platform === 'shopee' && !isShopeeIn30daysMemo;

  const { mutateAsync, isLoading } = useOrderNoteMutationWithList({
    internalTradeId,
    platform,
    isShopeeIn30daysMemo,
    queryParams,
    onSuccess: toggle,
  });

  const handleOk = () => {
    const value = inputValue?.trim();
    if (isLoading) return;
    mutateAsync(value || '');
  };

  useEffect(() => {
    setInputValue(content);
  }, [content]);

  return (
    <>
      {renderButton ? (
        renderButton(isEditState, toggle)
      ) : (
        <DefaultButton size="small" onClick={toggle}>
          {buttonText}
        </DefaultButton>
      )}
      <Modal
        width={430}
        bodyStyle={{ padding: 0 }}
        title={t('trade.commentContent')}
        visible={visible}
        onCancel={toggle}
        onOk={handleOk}
        okText={t('trade.save')}
        okButtonProps={{ loading: isLoading }}
      >
        {showTips && (
          <div className="bg-[var(--fett-surface-warning-bg)] text-[var(--fett-text-secondary)] px-4 py-[5px]">
            {t('sidebar.order.noteModal.shopee.tips')}
          </div>
        )}
        <div className="px-4 pt-4 pb-6">
          <Input.TextArea
            autoSize={{ minRows: 4, maxRows: 6 }}
            value={inputValue}
            maxLength={sellerMemosLimit}
            placeholder={t('trade.commentPlaceholder')}
            onChange={(e) => setInputValue(e.target.value)}
          />
        </div>
      </Modal>
    </>
  );
};
